import { CartsType, ProfilesMessageType } from "../../Type/Layout/Header";

export const notificationData = [
    {
        color:"primary",
        time:"10 min.",
        title:"Delivery processing",
        fontColor:"danger"
    },
    {
        color:"success",
        time:"1 hr",
        title:"Order Complete",
        fontColor:"success"
    },
    {
        color:"secondary",
        time:"3 hr",
        title:"Tickets Generated",
        fontColor:"secondary"
    },
    {
        color:"warning",
        time:"6 hr",
        title:"Delivery Complete",
        fontColor:"warning"
    }
]

export const cartsData : CartsType[] = [
    {
        img:"cart-img.jpg",
        userName:"Furniture Chair for Home",
        amount:"500"
    },
    {
        img:"cart-img.jpg",
        userName:"Furniture Table for Office",
        amount:"500"
    }
]

export const bookMarkData = [
    {
      icon: "form",
      path: `${process.env.PUBLIC_URL}/forms/formscontrols/formvalidation`,
      title: "Form",
      color: "primary",
    },
    {
      icon: "user",
      path: `${process.env.PUBLIC_URL}/users/userprofile`,
      title: "Profile",
      color: "secondary",
    },
    {
      icon: "table",
      path: `${process.env.PUBLIC_URL}/table/reactstraptable/basictable`,
      title: "Tables",
      color: "warning",
    },
  ];
export const messagesHeaderData = [ 
    {
        borderColor:"primary",
        image:"3.jpg",
        title:"Helen Walter",
        time:"Do you want to go see movie?",
    },
    {
        borderColor:"primary",
        image:"6.jpg",
        title:"Jason Borne",
        time:"Thank you for rating us.",
    },
    {
        borderColor:"primary",
        image:"10.jpg",
        title:"Sarah Loren",
        time:"What`s the project report update?",
    },
]

export const userProfilesData:ProfilesMessageType[] = [ 
    {
        name: "Account",
        icon:"User",
        link: `${process.env.PUBLIC_URL}/users/userprofile`
    },
    {
        name: "Inbox",
        icon:"Mail",
        link: `${process.env.PUBLIC_URL}/email/letterbox`
    },
    {
        name: "Taskboard",
        icon:"FileText",
        link:`${process.env.PUBLIC_URL}/app/task`
    },
    {
        name: "Settings",
        icon:"Settings",
        link: `${process.env.PUBLIC_URL}/users/useredit`
    },
    {
        name: "Log Out",
        icon:"LogOut",
        link:`${process.env.PUBLIC_URL}/login`
    },
]